import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, FileText } from 'lucide-react';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-sand">
      {/* Header */}
      <header className="bg-white border-b border-forest/10 sticky top-0 z-10">
        <div className="container mx-auto px-4 py-4 flex items-center gap-4">
          <Link to="/" className="text-forest hover:text-lime transition-colors">
            <ArrowLeft size={24} />
          </Link>
          <div className="flex items-center gap-2">
            <FileText className="text-lime" size={24} />
            <h1 className="text-xl font-semibold text-forest">Termos de Uso</h1>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 py-8 max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-2xl shadow-sm p-6 md:p-8 space-y-6"
        >
          <p className="text-stone text-sm">Última atualização: Abril de 2026</p>

          {/* Descrição */}
          <section>
            <h2 className="text-lg font-semibold text-forest mb-3">O que é o Vocalira?</h2>
            <p className="text-stone leading-relaxed">
              Vocalira é um aplicativo para prática de idiomas usando inteligência artificial. 
              Nosso objetivo é ajudar você a aprender e praticar conversação em diferentes idiomas 
              de forma natural e interativa.
            </p>
          </section>

          {/* Regras */}
          <section>
            <h2 className="text-lg font-semibold text-forest mb-3">Regras de Uso</h2>
            <ul className="text-stone leading-relaxed space-y-2">
              <li className="flex items-start gap-2">
                <span className="text-lime mt-1">•</span>
                <span>Não utilize o app para spam, assédio ou atividades ilegais.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-lime mt-1">•</span>
                <span>Você é responsável pelo uso da sua conta e pela segurança da sua senha.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-lime mt-1">•</span>
                <span>Não compartilhe sua conta com terceiros.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-lime mt-1">•</span>
                <span>Respeite os limites de uso do plano gratuito.</span>
              </li>
            </ul>
          </section>

          {/* IA */}
          <section>
            <h2 className="text-lg font-semibold text-forest mb-3">Inteligência Artificial</h2>
            <p className="text-stone leading-relaxed">
              As respostas do app são geradas por inteligência artificial e podem conter erros 
              gramaticais ou informações imprecisas. O Vocalira é uma ferramenta de prática, 
              não substitui professores ou cursos formais de idiomas.
            </p>
          </section>

          {/* Planos */}
          <section>
            <h2 className="text-lg font-semibold text-forest mb-3">Planos e Pagamentos</h2>
            <ul className="text-stone leading-relaxed space-y-2">
              <li className="flex items-start gap-2">
                <span className="text-lime mt-1">•</span>
                <span><strong>Plano Gratuito:</strong> 15 mensagens por dia, acesso a funcionalidades básicas.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-lime mt-1">•</span>
                <span><strong>Plano Premium:</strong> Mensagens ilimitadas, acesso completo a todos os recursos.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-lime mt-1">•</span>
                <span>Os pagamentos são processados de forma segura pelo Stripe.</span>
              </li>
            </ul>
          </section>

          {/* Cancelamento */}
          <section>
            <h2 className="text-lg font-semibold text-forest mb-3">Cancelamento</h2>
            <p className="text-stone leading-relaxed">
              Você pode cancelar seu plano Premium a qualquer momento. Após o cancelamento, 
              você continuará com acesso até o final do período já pago, depois voltará 
              automaticamente para o plano gratuito.
            </p>
          </section>

          {/* Privacidade */}
          <section>
            <h2 className="text-lg font-semibold text-forest mb-3">Privacidade</h2>
            <p className="text-stone leading-relaxed">
              Seus dados pessoais são tratados conforme nossa{' '}
              <Link to="/privacy" className="text-lime hover:underline font-medium">
                Política de Privacidade
              </Link>
              . Recomendamos a leitura completa.
            </p>
          </section>

          {/* Alterações */}
          <section>
            <h2 className="text-lg font-semibold text-forest mb-3">Alterações nos Termos</h2>
            <p className="text-stone leading-relaxed">
              Podemos atualizar estes termos ocasionalmente. Quando houver mudanças importantes, 
              você será notificado por email ou através do app.
            </p>
          </section>

          {/* Contato */}
          <section className="pt-4 border-t border-forest/10">
            <p className="text-stone text-sm">
              Dúvidas? Entre em contato conosco através do app ou por email.
            </p>
          </section>
        </motion.div>

        {/* Footer Links */}
        <div className="mt-6 text-center">
          <Link to="/privacy" className="text-forest hover:text-lime transition-colors text-sm">
            Ver Política de Privacidade
          </Link>
        </div>
      </main>
    </div>
  );
};

export default TermsPage;
